import { createSlice } from '@reduxjs/toolkit';

const { reducer, actions } = createSlice({
  name: 'devices',
  initialState: {
    items: {},
    selectedId: null,
    zoomToId: null,
    zoomToCounter: 0,
  },
  reducers: {
    refresh(state, action) {
      state.items = {};
      action.payload.forEach(item => state.items[item['id']] = item);
    },
    update(state, action) {
      action.payload.forEach(item => state.items[item['id']] = item);
    },
    select(state, action) {
      state.selectedId = action.payload.id;
    },
    zoomTo(state, action) {
      state.zoomToId = action.payload.id;
      state.zoomToCounter += 1;
    },
    remove(state, action) {
      delete state.items[action.payload];
    },
  }
});

export { actions as devicesActions };
export { reducer as devicesReducer };
